/* eslint-disable react-hooks/exhaustive-deps */

import { getAuth } from "firebase/auth";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";

export default function useRealsTimeNotifications() {
  const [Notifications, setNotifications] = useState([]);

  const receiverId = getAuth()?.currentUser?.uid;
  useEffect(() => {
    const q = query(
      collection(db, "notifications"),
      where("receiver_id", "array-contains", receiverId)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const realTimeData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setNotifications(realTimeData);
    });

    return () => {
      unsubscribe();
    };
  }, [receiverId]);
  return [Notifications];
}
